import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import { UpgradeIds, UpgradeTypes } from '../enums'

export default function TwoExponentRiseFactory(
	creatives: UpgradeFactoryInput[],
	department: DepartmentIds,
	startingPrice: number,
	baseId: UpgradeIds
) {
	return creatives.map((creative, index) => ({
		name: creative.name,
		resource: `${DepartmentIds[department]}_exponent_${index + 1}`,
		id: baseId + index,
		description: creative.description,
		cost: startingPrice * 40 ** index,
		effects: [
			{
				for: [department],
				results: [UpgradeTypes.TwoExponentRise]
			}
		],
		conditions: {
			purchased: [department]
		}
	}))
}
